import { MeasurementSystem } from '../types';

const conversions = {
  metric: {
    cups: 'ml',
    oz: 'g',
    lb: 'kg',
    tsp: 'ml',
    tbsp: 'ml'
  },
  imperial: {
    ml: 'fl oz',
    g: 'oz',
    kg: 'lb',
    l: 'pt'
  },
  us: {
    ml: 'cups',
    g: 'oz',
    kg: 'lb',
    l: 'qt'
  }
};

const conversionRates = {
  'cups_to_ml': 236.588,
  'oz_to_g': 28.3495,
  'lb_to_kg': 0.453592,
  'tsp_to_ml': 4.92892,
  'tbsp_to_ml': 14.7868,
  'ml_to_fl_oz': 0.033814,
  'g_to_oz': 0.035274,
  'kg_to_lb': 2.20462,
  'l_to_pt': 2.11338,
  'l_to_qt': 1.05669
};

export function convertMeasurement(
  amount: string,
  unit: string,
  system: MeasurementSystem
): string {
  const value = parseFloat(amount);
  if (isNaN(value)) return `${amount} ${unit}`;

  const lowerUnit = unit.toLowerCase();
  const targetSystem = conversions[system];
  
  if (!targetSystem || !targetSystem[lowerUnit]) {
    return `${amount} ${unit}`;
  }

  const targetUnit = targetSystem[lowerUnit];
  const conversionKey = `${lowerUnit}_to_${targetUnit}`;
  const rate = conversionRates[conversionKey as keyof typeof conversionRates];

  if (!rate) return `${amount} ${unit}`;

  const converted = value * rate;
  return `${converted.toFixed(1)} ${targetUnit}`;
}